import * as cx from 'classnames';
import { PB_MENU_SUBSCRIBED_PHOTOBLOGS } from 'mk/autogenerated/translations/SubscribedPhotoblogs.90e0459864cd0ae33e345473cc1c3d42'
import { photoblog_index_category_url } from 'mk/urls/functions';
import Link from 'mk2/components/Link';
import LoadingPlaceholder from 'mk2/components/LoadingPlaceholder';
import Panel from 'mk2/components/Panel';
import * as React from 'react';
import styles from './SubscribedPhotoblogs.mscss';

interface OwnProps {
    className?: string;
    lastVisitCountFriends: string;
}

type Props = OwnProps;

const SubscribedPhotoblogs: React.StatelessComponent<Props> = ({ className, lastVisitCountFriends }) => (
    <Panel className={cx(styles.SubscribedPhotoblogs, className)}>
        <Link className={styles.SubscribedPhotoblogs__link} to={photoblog_index_category_url('friends')}>
            {PB_MENU_SUBSCRIBED_PHOTOBLOGS}
            {lastVisitCountFriends &&
                <span className={styles.SubscribedPhotoblogs__counter}>{lastVisitCountFriends}</span>
            }
        </Link>
    </Panel>
);

SubscribedPhotoblogs.displayName = 'SubscribedPhotoblogs';

export default SubscribedPhotoblogs;

interface PlaceholderOwnProps {
    className?: string;
}

export const SubscribedPhotoblogsPlaceholder: React.StatelessComponent<PlaceholderOwnProps> = ({ className }) => (
    <Panel className={cx(styles.SubscribedPhotoblogsPLaceholder, className)}>
        <LoadingPlaceholder width={250} height={21} />
    </Panel>
);
